




























import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ProfileDocumentsView extends Vue {
  termsOfUse: { nomeDoDocumento: string; hospitalId: string; tipo: string; }[] | [] = []

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

    await this.getBackofficeAgendamentoStore.getAllHospitais()

    const hospitalWhichtHaveTermsOfUse = this.hospitals.filter(hospital => !!hospital.hospitalPossuiTermoDeUso)

    this.termsOfUse = hospitalWhichtHaveTermsOfUse.map(hospital => ({
      nomeDoDocumento: `TERMOS DE USO - ${hospital.nome}`,
      hospitalId: hospital.id,
      tipo: 'TermoDeUso',
    }))

    EventBus.$emit('clearLoadingRequest')
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get hospitals() {
    return this.getBackofficeAgendamentoStore.hospitais || []
  }

  async openDocumentDetails(document: {
    nomeDoDocumento: string,
    tipo: string,
    hospitalId: string,
  }) {
    const { tipo: documentType, hospitalId } = document

    if (documentType === 'TermoDeUso') {
      this.$router.push({ name: 'hospital-terms-of-use', params: { hospitalId } })
    }
  }
}
